import {useEffect, useRef} from 'react';
import {getRealtimeMessages} from '../../../../../redux/realtime/realtimeActions';
import {useSelector} from 'react-redux';
import MobilePopup from '../../../../../component/newPopup/mobilePopup/MobilePopup';
import useShow from '../../../../../hooks/useShow';
import {TSystemMessage} from '../../../../../redux/realtime/realtime.type';
import SystemMessageSwiper from './systemMessageSwiper';
import setGlobalState from '../../../../../redux/setGlobalState';
import {useParams, useLocation} from 'react-router-dom';
import {shouldDisplaySystemMessage} from './useSystemMessageFilter';

function SystemMessageDisplayPop({messagePreview, onClose,isPreview=false}:{messagePreview?: TSystemMessage, onClose?: any,isPreview?: boolean}){
    const allPopMessages = useSelector((s: any) => s.realtime.systemMessage?.popMessages);
    const accountPid = useSelector((s: any) => s.account?.pid);
    const {page, eid, pid} = useParams();
    const location = useLocation();
    // Use pid from URL when in package context, otherwise use account.pid for exclusion check (e.g. when viewing event)
    const effectivePid = pid ?? accountPid?.toString();
    const show = useShow();
    const systemMessageXHR = useSelector((s:any) => s.realtime.getSystemMessageXHR);
    const isViewed = useSelector((s:any) => s.realtime.systemMessage.isViewed);
    const originalTitleRef = useRef(null);
    const isPopupOpenRef = useRef(false);
    const systemMessageTitle = 'system message - הודעת מערכת';

    // Filter messages that should display in popup based on current route context
    const systemMessage = messagePreview
        ? [messagePreview]
        : allPopMessages?.filter(m => m.displayInPop && shouldDisplaySystemMessage(m, location.pathname, page, eid, effectivePid)) ?? [];

    const displayPop = !!systemMessage?.find(m=>m.displayInPop);
    const hasUnviewedMessages = systemMessage?.some(m => !isViewed?.includes(m.smid));

    useEffect(() => {
        if(!originalTitleRef.current) {
            originalTitleRef.current = document.title;
        }
        const isPopupOpen = show.isOpen;
        if(isPopupOpenRef.current && !isPopupOpen) {
            if(originalTitleRef.current) {
                document.title = originalTitleRef.current;
            }
        }

        if(isPopupOpen && !isPopupOpenRef.current) {
            const newTitle = `Tickchak | ${systemMessageTitle}`;
            document.title = newTitle;
        }
        isPopupOpenRef.current = isPopupOpen;
    }, [show.isOpen]);

    useEffect(()=>{
        if(!systemMessageXHR && (eid || pid))
            getRealtimeMessages(eid, pid).then();
        if(displayPop && (hasUnviewedMessages || isPreview))
            show.open();
    },[]);
    // hasUnviewedMessages in deps ensures popup stays closed after user dismisses it
    useEffect(()=>{
        if(displayPop && (hasUnviewedMessages || isPreview))
            show.open();
        else
            show.close();
    },[displayPop, hasUnviewedMessages]);

    const close = () => {
        show.close();
        onClose && onClose();
        const viewedSmids = systemMessage?.map(m => m.smid) || [];
        setGlobalState('realtime.systemMessage.isViewed', [...(isViewed || []), ...viewedSmids]);
    };

    return (
        (displayPop || messagePreview) && show.isOpen? <MobilePopup
            showClass={show.showClass}
            close={close}
            title={undefined}
            list={undefined}
            forwardRef={undefined}
            dataCyName={'systemMessagePop'}
            height={'90%'}
            cssStyle={'height:456px; width:440px;'}
            TopComponent={<></>}
        >
            <SystemMessageSwiper isPop={true} defaultMessages={systemMessage} closePop={close} />
        </MobilePopup>:<></>
    );
}

export default SystemMessageDisplayPop;
